export default [  
  {
    path: '/orders',
    name: 'orders',
    component: () => import('@/views/modules/orders/list'),
    meta: {
      requiresAuth: true,
      layout: 'app',
      breadcrumb: [
        { text: 'Dashboard', to: { name: "dashboard" }  },
        { text: 'Orders' }
      ]
    },
    children:[    
      
    ]
  },
  {
    path: '/orders/:id/show',
    props: true,
    name: 'orders-show',
    component: () => import('@/views/modules/orders/show'),
    meta: {
      sidebarToggle: true,
      requiresAuth: true,
      layout: 'app',
      breadcrumb: [
        { text: 'Dashboard',to: { name: "dashboard" }  },
        { text: 'Orders', to: { name: "orders" }  },
        { text: 'Details' }
      ]
    }
  },

]